export default "__VITE_ASSET__DJYgDTvF__"